var map = {
	"./city/index-btn-frens-active.png": 6749,
	"./city/index-btn-frens.png": 23159,
	"./city/new/index-btn-frens-active.png": 17984,
	"./city/new/index-btn-frens.png": 76214,
	"./tapcoin/index-btn-frens.png": 94744
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3969;